module.exports = __webpack_public_path__ + "img/settings.1ec0e143.svg";